module.exports = __webpack_public_path__ + "img/group-2.f8e3c365.jpg";